import { GroupMemberDataFromSearchResult } from "../../interfaces/group.interface";
import { User } from "../../interfaces/user.interface"

export function getFormmatedUserFullName(user: User | GroupMemberDataFromSearchResult, includesEmail?: boolean): string {
    let first_name = user?.first_name ?? ''
    let last_name = user?.last_name ?? ''

    if (first_name && last_name) {
        let formmatedFullName = first_name + ' ' + last_name;

        if (includesEmail) {
            return `${formmatedFullName} (${user.email})`;
        } else {
            return formmatedFullName;
        }

    } else {
        return user.email;
    }
}

export function formatDateToBrazilianPattern(dateString: string) {
    const iso8601Regex = /^(\d{4})-(\d{2})-(\d{2})(T(\d{2}):(\d{2}):(\d{2})(\.(\d{3}))?(Z)?)?$/;

    if (!dateString || !iso8601Regex.test(dateString))
        return '';

    const dateObj = new Date(dateString);
    return dateObj.toLocaleDateString('pt-BR', { day: 'numeric', month: 'numeric', year: 'numeric' });
};